export enum FilterOperator { eq = 'eq', ne = 'ne', contains = 'contains', gt = 'gt', ge = 'ge', lt = 'lt', le = 'le' }

export const FILTEROPERATORSSTRING = [FilterOperator.contains, FilterOperator.eq, FilterOperator.ne];
export const FILTEROPERATORSNUMBER = [FilterOperator.eq, FilterOperator.ne, FilterOperator.gt, FilterOperator.ge, FilterOperator.lt, FilterOperator.le];
export const FILTEROPERATORSDATE = [FilterOperator.eq, FilterOperator.ne, FilterOperator.gt, FilterOperator.ge, FilterOperator.lt, FilterOperator.le];

export enum FilterValueType { string, number, date, boolean }

/** Call back method, called from within custom OnRenderCustomType */
export type OnSelectCustomValue = (value?: string, listId?: string) => void;

/** Type for rendering custom filter */
export type OnRenderCustomType = (filter: IFilter, value?: string, onChange?: OnSelectCustomValue, listId?: string) => JSX.Element;

/** Type for custom handling of deserialization of filter from given params. Should return filter to add to all filter and-wise. */
export type OnDeserializeCustom = (filter: IFilter, params: URLSearchParams, listId?: string) => string[] | undefined;

export interface IFilter {
  /** Friendly display name fo filter. */
  name: string;

  /** Id used to represent selection in url. */
  id: string;

  /** Optional name of field for query in case it differs from @see id. */
  field?: string;

  /** Array of options for closed domain filters. If set filter will be presented as a closed domain, otherwise an open input value. */
  options?: IFilterOption[];

  /** Text to show as placeholder in input value. */
  placeholderText?: string;

  /** Selected operator to use for comparison. Defaults to eq. */
  operator?: FilterOperator;

  /** Available operators for comparison. */
  operators?: FilterOperator[];

  /** Optional value type. Needed for proper serialization to server and to determine type of input control to render. Defaults to string. */
  valueType?: FilterValueType;

  /** Hidden filter will be deserialized from params but are not visible. */
  hidden?: boolean;

  /** Set to true to make sure filter is initially collapsed (currently only supported for filters with @see options set and no value selected) */
  collapsed?: boolean;

  /** Set to true if this filter is to be used as search field in request to server. Only for fields that render as open input value. */
  isSearch?: boolean;

  /** Callback method to determine if filter is available. */
  isAvailable?: (filter: IFilter, params: URLSearchParams, listId?: string) => boolean;

  /** Callback method to handle filter in a custom way including rendering. */
  renderCustom?: OnRenderCustomType;

  /** Callback method to handle custom filter deserialization. */
  deserializeCustom?: OnDeserializeCustom;
}

export interface IFilterOption {
  /** Unique identification. */
  id: string;

  /** Friendly name. */
  name?: string;

  /** Value associated with option. Used in combination with @see operator. */
  value?: string | number | boolean;

  /** Operator to be used with @see value. Defaults to equal (eq). */
  operator?: FilterOperator;

  /** Expression to override @see value and @see operator. */
  expression?: string;
}